"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var lodash_1 = require("lodash");
var DEFAULT_PLACEHOLDER_COUNT = 6;
var Tiles = /** @class */ (function (_super) {
    tslib_1.__extends(Tiles, _super);
    function Tiles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasLoaded: false,
        };
        return _this;
    }
    Tiles.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.hasLoaded)
            return;
        this.setState({
            hasLoaded: true,
        });
    };
    Tiles.prototype.hasChildren = function () {
        return React.Children.count(this.props.children) > 0;
    };
    Tiles.prototype.isEmpty = function () {
        return !this.props.loading && !this.hasChildren();
    };
    Tiles.prototype.isInitializing = function () {
        return !this.state.hasLoaded && this.props.loading;
    };
    Tiles.prototype.isReloading = function () {
        return this.state.hasLoaded && this.props.loading;
    };
    Tiles.prototype.renderPlaceholder = function () {
        var _this = this;
        if (!this.isInitializing())
            return null;
        if (!this.props.placeholder)
            return null;
        return lodash_1.times(this.props.expectedCount, function (idx) {
            return (React.createElement("li", { className: "tiles__tile", key: idx }, _this.props.placeholder));
        });
    };
    Tiles.prototype.renderGrid = function () {
        if (this.isInitializing())
            return null;
        return React.Children.map(this.props.children, function (child, idx) {
            if (!child)
                return null;
            return (React.createElement("li", { className: "tiles__tile", key: idx }, child));
        });
    };
    Tiles.prototype.renderFlexFix = function () {
        if (this.props.singleRow ||
            this.props.oneWide ||
            this.props.grow ||
            (this.props.centered && this.props.threeWide))
            return null;
        return lodash_1.times(DEFAULT_PLACEHOLDER_COUNT, function (idx) { return (React.createElement("li", { className: "tiles__tile", key: idx })); });
    };
    Tiles.prototype.renderViewMoreTile = function () {
        if (!this.props.singleRow ||
            !this.props.viewMoreURL ||
            React.Children.count(this.props.children) <= DEFAULT_PLACEHOLDER_COUNT)
            return null;
        return (React.createElement("li", { className: "tiles__tile" },
            React.createElement("div", { className: "tiles__view-more" },
                React.createElement("a", { className: "tiles__view-more__link", href: this.props.viewMoreURL }))));
    };
    Tiles.prototype.render = function () {
        var classes = classNames('tiles', { 'tiles--single-row': this.props.singleRow }, { 'tiles--grow': this.props.grow }, { 'tiles--one-wide': this.props.oneWide }, { 'tiles--one-wide-mobile': this.props.oneWideMobile }, { 'tiles--three-wide': this.props.threeWide }, { 'tiles--two-wide': this.props.twoWide }, { 'tiles--four-wide-max': this.props.fourWideMax }, { 'tiles--large': this.props.largeTiles }, { 'tiles--centered': this.props.centered }, { 'tiles--reloading': this.isReloading() });
        if (this.isEmpty()) {
            return this.props.emptyState;
        }
        if (this.props.renderAsOrderedList) {
            return (React.createElement("ol", { className: classes },
                this.renderPlaceholder(),
                this.renderGrid(),
                this.renderViewMoreTile(),
                this.renderFlexFix()));
        }
        return (React.createElement("ul", { className: classes },
            this.renderPlaceholder(),
            this.renderGrid(),
            this.renderViewMoreTile(),
            this.renderFlexFix()));
    };
    Tiles.defaultProps = {
        emptyState: null,
        expectedCount: DEFAULT_PLACEHOLDER_COUNT,
    };
    return Tiles;
}(React.Component));
exports.default = Tiles;
//# sourceMappingURL=tiles.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/tiles.js
// module id = odvp
// module chunks = 20 21